import * as jsxRuntime from "/home/jenkins/agent/workspace/epb-only-nodejs-054deb29-a3c3-4672-a0a3-1c872bcc1c93/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment